import { Button, type ButtonProps, Icon, Text } from "@chakra-ui/react";
import { type PropsWithChildren } from "react";

import { CloseIcon } from "../../assets/icons";

type TagProps = {
  onClick?: () => void;
  isClosable?: boolean;
  variant?: "rounded" | "square";
} & Omit<ButtonProps, "variant">;

const variants = {
  rounded: "tag",
  square: "squareTag",
};

export const Tag = ({
  onClick,
  isClosable = false,
  children,
  variant = "rounded",
  ...props
}: PropsWithChildren<TagProps>) => (
  <Button
    width="fit-content"
    _hover={{
      background: onClick ? "gray.300" : "gray.100",
    }}
    cursor={onClick ? "pointer" : "auto"}
    onClick={onClick}
    rightIcon={isClosable ? <Icon as={CloseIcon} /> : undefined}
    variant={variants[variant]}
    {...props}
  >
    <Text
      overflow="hidden"
      maxWidth={{ base: "150px", md: "250px" }}
      whiteSpace="nowrap"
      textOverflow="ellipsis"
    >
      {children}
    </Text>
  </Button>
);
